import React, {useState} from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { okaidia } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { useSnackbar } from 'notistack';
import { saveAs } from "file-saver";

const formatCode = (code) => {
    return code.trim().replace(/\n\s*\n/g, '\n');
};


const CodeBlock = ({ codeString, language }) => {
    const formattedCode = formatCode(codeString);
    const [copied, setCopied] = useState(false);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(formattedCode);
        setCopied(true);
        enqueueSnackbar('Code has been copied to the clipboard', { variant: 'info' });
        setTimeout(() => setCopied(false), 2000);
    };
    const { enqueueSnackbar } = useSnackbar();

    const saveCodeToFile = () => {
        const blob = new Blob([formattedCode], { type: "text/plain;charset=utf-8" });
        saveAs(blob, "SpaceEngineersScript.cs");
    };


    return (
        <>
            <button className="btn btn-dark mx-1" onClick={copyToClipboard}>
                {copied ? "✅ Copied!" : "📋 Copy"}
            </button>
            <button className="btn btn-dark mx-1" onClick={saveCodeToFile}>💾 Download C# File</button>
            <SyntaxHighlighter
                language={language}
                style={okaidia}
                wrapLines={true}
                showLineNumbers={true}
                lineProps={{style: {whiteSpace: 'pre-wrap'}}}
            >
                {formattedCode}
            </SyntaxHighlighter>
        </>
    )
        ;
};

export default CodeBlock;
